import React, { useEffect, useState } from "react";
import "./Provider.css";
import { toast } from "react-toastify";
import Spinner from "../../Spin/Spinner";
import { useSelector } from "react-redux";
import Select from "react-select";
import { addOrganization, fetchAllProviders } from "../../../config/LiveApi";

const AddOrgForm = ({
  formData,
  handleInputChange,
  setFormData,
  initialFormValue,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [providersName, setProvidersName] = useState([]);

  const token = useSelector((store) => store.userReducer.token);

  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;

    if (name === "payinProviderID") {
      const selectedProvider = providersName.find(
        (p) => p.id === selectedOption.value
      );
      setFormData({
        ...formData,
        payinProviderID: selectedOption.value,
        payinProviderName: selectedProvider.providerName, // Map to the name
      });
    } else if (name === "payoutProviderID") {
      const selectedProvider = providersName.find(
        (p) => p.id === selectedOption.value
      );
      setFormData({
        ...formData,
        payoutProviderID: selectedOption.value,
        payoutProviderName: selectedProvider.providerName, // Map to the name
      });
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await addOrganization(token, formData);
      toast.success("Organization added successfully");
    } catch (err) {
      console.error("Error adding organization:", err.message);

      // If backend returned validation error array → "All fields required"
      if (err.response?.status === 400 && Array.isArray(err.response?.data?.message)) {
        toast.error("All fields are required.");
      }else{
        // Otherwise generic error
        toast.error("Unable to add organization.");
      }

    }
    setFormData(initialFormValue);
    setIsLoading(false);
  };

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const response = await fetchAllProviders(token);
        const providerName = response.data.providers;
        setProvidersName(providerName);
      } catch (error) {
        console.error("Error fetching providers:", error);
      }
    };

    fetchProviders();
  }, [token]);

  return (
    <div className="provider-form">
      {isLoading ? (
        <Spinner />
      ) : (
        <form onSubmit={onSubmit}>
          <p className="label-data">Organization Name</p>
          <input
            type="text"
            name="orgName"
            placeholder="Organization Name"
            value={formData.orgName}
            onChange={handleInputChange}
          />

          {/* <p className="label-data">Payin Provider Name</p>
          <Select
            name="payinProviderID"
            value={
              providersName
                .map((p) => ({
                  label: `${p.providerName}_${p.orgName}`,
                  value: p.id,
                  name: "payinProviderID",
                }))
                .find((option) => option.value === formData?.payinProviderID) || null
            }
            onChange={handleSelectChange}
            options={providersName.map((p) => ({
              label: `${p.providerName}_${p.orgName}`,
              value: p.id,
              name: "payinProviderID",
            }))}
          />

          <p className="label-data">Payout Provider Name</p>
          <Select
            name="payoutProviderID"
            value={
              providersName
                .map((p) => ({
                  label: `${p.providerName} - ${p.orgName}`,
                  value: p.id,
                  name: "payoutProviderID",
                }))
                .find((option) => option.value === formData?.payoutProviderID) || null
            }
            onChange={handleSelectChange}
            options={providersName.map((p) => ({
              label: `${p.providerName} - ${p.orgName}`,
              value: p.id,
              name: "payoutProviderID",
            }))}
          /> */}

          <p className="label-data">Organization Domain URL</p>
          <input
            type="text"
            name="orgDomainURL"
            placeholder="Organization Domain URL"
            value={formData.orgDomainURL}
            onChange={handleInputChange}
          />

          <p className="label-data">Organization Logo URL</p>
          <input
            type="text"
            name="orgLogo"
            placeholder="Organization Logo URL"
            value={formData.orgLogo}
            onChange={handleInputChange}
          />

          <p className="label-data">Organization Address</p>
          <input
            type="text"
            name="orgAddress"
            placeholder="Organization Address"
            value={formData.orgAddress}
            onChange={handleInputChange}
          />

          <p className="label-data">Organization Phone Number</p>
          <input
            type="text"
            name="orgPhoneNumber"
            placeholder="Organization Phone Number"
            value={formData.orgPhoneNumber}
            onChange={handleInputChange}
          />

          <p className="label-data">Organization GSTIN</p>
          <input
            type="text"
            name="orgGSTIN"
            placeholder="Organization GSTIN"
            value={formData.orgGSTIN}
            onChange={handleInputChange}
          />

          <p className="label-data">Organization Company Name</p>
          <input
            type="text"
            name="orgCompanyName"
            placeholder="Organization Company Name"
            value={formData.orgCompanyName}
            onChange={handleInputChange}
          />

          <p className="label-data">IP Address - 01</p>
          <input
          required
            type="text"
            name="ip01"
            placeholder="IP Address - 01"
            value={formData.ip01}
            onChange={handleInputChange}
          />

           <p className="label-data">IP Address - 02</p>
          <input
          required
            type="text"
            name="ip02"
            placeholder="IP Address - 02"
            value={formData.ip02}
            onChange={handleInputChange}
          />

          <div className="modal-buttons">
            <button className="btn-addOrg" type="submit">
              Add Organization
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddOrgForm;
